var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThighs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "66px",
    viewBox: "0 0 59 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Thighs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-41",
    transform: "translate(-186.000000, -186.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5442132,143.318119 L13.224895,145.318148 C21.5322999,142.78798 28.6542676,144.186063 34.5897728,149.512313 C34.6771296,149.307379 34.7723553,149.107716 34.8749951,148.913849 C34.2728188,150.051355 33.925902,151.388006 33.925902,152.818148 C33.925902,156.470521 36.1885488,159.513121 39.184713,160.181568 L38.4331112,194.355786 L39.5560353,209.318148 L21.3289426,209.318148 C17.6058755,192.800474 14.9735148,179.968939 13.4318603,170.823542 L13.2708567,169.857783 C12.8787817,167.478648 12.564962,165.363985 12.3293978,163.513793 C11.1829851,154.509524 11.4814842,147.777643 13.224895,143.318148 L13.5442132,143.318119 Z M67.9783535,143.318148 C69.7217643,147.777643 70.0202634,154.509524 68.8738508,163.513793 C68.6382865,165.363985 68.3244669,167.478648 67.9323918,169.857783 L67.7713882,170.823542 C66.2572633,179.805628 63.6910381,192.34338 60.0727126,208.436799 L59.874306,209.318148 L41.6472132,209.318148 L42.7701373,194.355786 L42.0162132,160.09133 L42.238209,160.022757 C44.9461745,159.117432 46.925902,156.234554 46.925902,152.818148 C46.925902,151.782614 46.7440176,150.796097 46.4150997,149.89881 L46.3734947,149.790428 L46.3734947,149.790428 C52.4494702,144.018001 59.6220156,142.527241 67.8911309,145.318148 C67.8039258,144.615617 67.7199795,143.948678 67.6392922,143.31733 L67.9783535,143.318148 Z",
    id: "Thighs"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThighs);
export default __webpack_public_path__ + "static/media/Thighs.d9368e22fe5d8fa3f43388066f3af439.svg";
export { ForwardRef as ReactComponent };